export default {
  data() {
    return {
      selectedItem: null,
      showModal: false,
    }
  },

  methods: {

    /*     
     * Used to show modal and save file for deleting
     * arg The argument is an integer value representing item
     * return {void}
     */
    showDeleteModal(item) {
      this.showModal = true;
      this.selectedItem = item;
    },

    /*
      * Used to close modal
      * return {void}
     */
    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
    },
  }
}
